export class Config {
    static ApiBaseUrl: string = 'https://signemailtestapi.sperse.com';
    static ImageContainerVirtualUrl: string = '/Content/UserImages/';
    static GetUsersApiUrl: string = '/api/Users/';
    static PostUsersApiUrl: string = '/api/Users/';
}